export const CROSSWORD_PUBLISHER_DATA = [
	{
		crosswordId: "NYT-CROS",
		iconPath: "/static/images/crossword/im-cw-1@2x.png",
		slug: "new-york-times-crossword",
		breadcrumbs: "NYT CROSSWORD ANSWERS",
		h1: "New York Times Crossword Daily Answers",
		subtitle:
			"Step into a world of wordcraft with The New York Times’ crossword puzzle solutions, where history meets linguistic innovation.",
		h2: "{Month} {Day}, {Year} Crossword Clues",
		shortTitle: "New York Times",
		metaTitle: "New York Times Crossword Answers | {Month} {Day}, {Year}",
		metaDescription:
			"Find all the answers to today's New York Times crossword puzzle. Updated daily!",
	},
	{
		crosswordId: "NYT-MINI",
		iconPath: "/static/images/crossword/im-cw-2@2x.png",
		slug: "new-york-times-mini-crossword",
		breadcrumbs: "NYT THE MINI CROSSWORD ANSWERS",
		h1: "New York Times The Mini Crossword Daily Answers",
		subtitle:
			"Find all of today's answers to The Mini Daily Crossword from the New York Times. Updated every day!",
		h2: "{Month} {Day}, {Year} Crossword Clues",
		shortTitle: "NYT The Mini",
		metaTitle:
			"New York Times The Mini Crossword Answers | {Month} {Day}, {Year}",
		metaDescription:
			"Find all the answers to today's New York Times The Mini crossword puzzle. Updated daily!",
	},
	{
		crosswordId: "USA-CROS",
		iconPath: "/static/images/crossword/im-cw-3@2x.png",
		slug: "usa-today-crossword",
		breadcrumbs: "USA TODAY CROSSWORD ANSWERS",
		h1: "USA Today Crossword Daily Answers",
		subtitle:
			"Celebrate a new perspective and the ideal balance of challenge and reward with the USA Today crosswords.",
		h2: "{Month} {Day}, {Year} Crossword Clues",
		shortTitle: "USA Today",
		metaTitle: "USA Today Crossword Answers | {Month} {Day}, {Year}",
		metaDescription:
			"Find all the answers to today's USA Today crossword puzzle. Updated daily!",
	},
	{
		crosswordId: "USA-QUIC",
		iconPath: "/static/images/crossword/im-cw-4@2x.png",
		slug: "usa-today-quick-cross",
		breadcrumbs: "USA TODAY QUICK CROSS ANSWERS",
		h1: "USA Today Quick Cross Crossword Daily Answers",
		subtitle:
			"Get answers for today's USA Today Quick Cross crossword puzzle. Updated daily!",
		h2: "{Month} {Day}, {Year} Crossword Clues",
		shortTitle: "USA Today Quick Cross",
		metaTitle: "USA Today Quick Cross Answers | {Month} {Day}, {Year}",
		metaDescription:
			"Find all the answers to today's USA Today Quick Cross crossword puzzle. Updated daily!",
	},
	{
		crosswordId: "ARP-CROS",
		iconPath: "/static/images/crossword/im-cw-5@2x.png",
		slug: "aarp-crossword",
		breadcrumbs: "AARP CROSSWORD ANSWERS",
		h1: "AARP Crossword Daily Answers",
		subtitle:
			"Choose a challenge that's just right for you with the AARP crossword puzzle.",
		h2: "{Month} {Day}, {Year} Crossword Clues",
		shortTitle: "AARP",
		metaTitle: "AARP Crossword Answers | {Month} {Day}, {Year}",
		metaDescription:
			"Find all the answers to today's AARP crossword puzzle. Updated daily!",
	},
	{
		crosswordId: "LAT-CROS",
		iconPath: "/static/images/crossword/im-cw-6@2x.png",
		slug: "los-angeles-times-crossword",
		breadcrumbs: "LOS ANGELES TIMES CROSSWORD ANSWERS",
		h1: "Los Angeles Times Crossword Daily Answers",
		subtitle:
			"Your daily dose of brain training with the LA Times Crossword.",
		h2: "{Month} {Day}, {Year} Crossword Clues",
		shortTitle: "Los Angeles Times",
		metaTitle:
			"Los Angeles Times Crossword Answers | {Month} {Day}, {Year}",
		metaDescription:
			"Find all the answers to today's Los Angeles Times crossword puzzle. Updated daily!",
	},
];
